/***
 * Created on 2023/8/21
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import ic_monitor_svg from '../../../../static/img/utils/ic-monitor.svg';

function TrustCurrentDevice(props) {
    return (
        <div className="comp-content-wrapper">
            <div className="trusted-device__row">
                <div className="trusted-device__row__col-left set-divide-right">
                    <div className="comp-group-info">
                        <div className="group-info--img">
                            <img src={ic_monitor_svg} alt="" />
                        </div>
                        <div className="group-info--detail">
                            <div className="group-info--detail__main-text text-ellipsis">Windows Chrome</div>
                            <div
                                className="group-info--detail__sub-text">您在信任的電腦上登入時，您不需要輸入驗證碼即可存取您的帳號
                            </div>
                        </div>
                    </div>
                </div>
                <div className="trusted-device__row__col-right">
                    <div className="comp-switch">
                        <div className={`q-switch switch-off`}></div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TrustCurrentDevice;